import Vue from 'vue'
import http from '@/utils/ajax'
import { ADMINB2C_INIT_LOADING, ADMINB2C_INIT_SUCCESS, ADMINB2C_INIT_FAIL, ADMINB2C_KEYS_INTERMEDIARY, ADMINB2C_KEYS_INIT_LOADING, ADMINB2C_KEYS_INIT_SUCCESS, ADMINB2C_KEYS_INIT_FAIL, ADMINB2C_REF_INIT_LOADING, ADMINB2C_REF_INIT_SUCCESS, ADMINB2C_REF_INIT_FAIL, ADMINB2C_REF_KEYS, ADMINB2C_KEYPRODUCTS_INIT_LOADING, ADMINB2C_KEYPRODUCTS_INIT_SUCCESS, ADMINB2C_KEYPRODUCTS_INIT_FAIL } from '@/store/types'
import { extractMenu, extractMessages } from '@/utils/extract'
const state = {
  // 0: Loading, 1: Success, 2: Fail
  init: 0,
  initErr: [],
  // API menu
  menu: {},
  keys: {
    // 0: Loading, 1: Success, 2: Fail
    init: 0,
    initErr: [],
    // API menu
    menu: {},
    intermediaryList: [],
    b2cKeyProductList: []
  },
  referrers: {
    // 0: Loading, 1: Success, 2: Fail
    init: 0,
    initErr: [],
    // API menu
    menu: {},
    keys: []
  }
}
const getters = {
}
const mutations = {
  [ADMINB2C_INIT_LOADING](state) {
    state.init = 0
    state.initErr = []
    state.menu = {}
  },
  [ADMINB2C_INIT_SUCCESS](state, data) {
    state.init = 1
    state.initErr = []
    state.menu = data.menu
  },
  [ADMINB2C_INIT_FAIL](state, error) {
    state.init = 2
    state.initErr = error
    state.menu = {}
  },
  [ADMINB2C_KEYS_INIT_LOADING](state) {
    state.keys.init = 0
    state.keys.initErr = []
    state.keys.menu = {}
  },
  [ADMINB2C_KEYS_INIT_SUCCESS](state, data) {
    state.keys.init = 1
    state.keys.initErr = []
    state.keys.menu = data.menu
  },
  [ADMINB2C_KEYS_INIT_FAIL](state, error) {
    state.keys.init = 2
    state.keys.initErr = error
    state.keys.menu = {}
  },
  [ADMINB2C_KEYS_INTERMEDIARY](state, data) {
    Vue.set(state.keys, 'intermediaryList', data)
  },
  [ADMINB2C_KEYPRODUCTS_INIT_LOADING](state) {
    state.keys.init = 0
    state.keys.initErr = []
    state.keys.menu = {}
  },
  [ADMINB2C_KEYPRODUCTS_INIT_SUCCESS](state, data) {
    state.keys.init = 1
    state.keys.initErr = []
    state.keys.menu = data.menu
  },
  [ADMINB2C_KEYPRODUCTS_INIT_FAIL](state, error) {
    state.keys.init = 2
    state.keys.initErr = error
    state.keys.menu = {}
  },
  [ADMINB2C_REF_INIT_LOADING](state) {
    state.referrers.init = 0
    state.referrers.initErr = []
    state.referrers.menu = {}
  },
  [ADMINB2C_REF_INIT_SUCCESS](state, data) {
    state.referrers.init = 1
    state.referrers.initErr = []
    state.referrers.menu = data.menu
  },
  [ADMINB2C_REF_INIT_FAIL](state, error) {
    state.referrers.init = 2
    state.referrers.initErr = error
    state.referrers.menu = {}
  },
  [ADMINB2C_REF_KEYS](state, data) {
    Vue.set(state.referrers, 'keys', data)
  }
}
const actions = {
  async b2cManagementInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.b2cManagement
    commit(ADMINB2C_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(ADMINB2C_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(ADMINB2C_INIT_FAIL, extractMessages(error))
    }
  },
  async b2cKeysInit({ commit }) {
    const apiUrl = state.menu.b2cKey
    commit(ADMINB2C_KEYS_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(ADMINB2C_KEYS_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(ADMINB2C_KEYS_INIT_FAIL, extractMessages(error))
    }
  },
  async b2cRefsInit({ commit }) {
    const apiUrl = state.menu.referrer
    commit(ADMINB2C_REF_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(ADMINB2C_REF_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(ADMINB2C_REF_INIT_FAIL, extractMessages(error))
    }
  },
  async b2cKeyProductsInit({ commit, state }) {
    const apiUrl = state.menu.getKeyProduct
    if (apiUrl) {
      commit(ADMINB2C_KEYPRODUCTS_INIT_LOADING)
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu: menu
        }
        commit(ADMINB2C_KEYPRODUCTS_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(ADMINB2C_KEYPRODUCTS_INIT_FAIL, extractMessages(error))
      }
    } else {
      commit(ADMINB2C_KEYPRODUCTS_INIT_FAIL, ['Invalid API URL'])
    }
  }
}
export default {
  state,
  getters,
  mutations,
  actions
}
